'use client';

import { c as _c } from "react/compiler-runtime";
import { weeklyScores } from '@/lib/fantasy-extras';
import { managerToTeam, teams } from './_data';

// Mini hover-card for manager-name callouts in body copy

export function ManagerTag(t0) {
  const $ = _c(46);
  const {
    name
  } = t0;
  const teamName = managerToTeam[name];
  let t1;
  if ($[0] !== teamName) {
    t1 = teams.find(t => t.team === teamName);
    $[0] = teamName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const team = t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== name || $[3] !== team || $[4] !== teamName) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t12;
      bb1: {
        if (!teamName) {
          t12 = [] as string[];
          break bb1;
        }
        let t13;
        if ($[15] !== teamName) {
          t13 = r => r.team === teamName;
          $[15] = teamName;
          $[16] = t13;
        } else {
          t13 = $[16];
        }
        t12 = weeklyScores.filter(t13).sort(_temp).slice(-5).map(_temp2);
      }
      const last5 = t12;
      if (!team) {
        let t13;
        if ($[17] !== name) {
          t13 = <span className="font-black">{name}</span>;
          $[17] = name;
          $[18] = t13;
        } else {
          t13 = $[18];
        }
        t11 = t13;
        break bb0;
      }
      t9 = "group relative inline-block cursor-help font-black underline decoration-[#8a3f31]/60 decoration-dotted underline-offset-2";
      t10 = name;
      t5 = "pointer-events-none invisible absolute top-full left-1/2 z-50 mt-2 w-72 -translate-x-1/2 border border-[#24122f] bg-[#fffaf1] p-4 text-left text-[#24122f] opacity-0 shadow-[6px_6px_0_#24122f] transition group-hover:visible group-hover:opacity-100";
      if ($[19] !== team.persona) {
        t6 = <span className="block text-xs font-black tracking-wide text-[#8a3f31] uppercase">{team.persona}</span>;
        $[19] = team.persona;
        $[20] = t6;
      } else {
        t6 = $[20];
      }
      if ($[21] !== team.team) {
        t7 = <span className="mt-1 block font-sans text-2xl leading-tight font-black">{team.team}</span>;
        $[21] = team.team;
        $[22] = t7;
      } else {
        t7 = $[22];
      }
      let t13;
      if ($[23] !== team.rank) {
        t13 = <span className="rounded-sm bg-[#24122f] px-2 py-1 text-[#fff5d6]">#{team.rank}</span>;
        $[23] = team.rank;
        $[24] = t13;
      } else {
        t13 = $[24];
      }
      let t14;
      if ($[25] !== team.pointsFor || $[26] !== team.tablePoints) {
        t14 = <span className="text-[#6f6078]">{team.tablePoints} TBL · {team.pointsFor} PF</span>;
        $[25] = team.pointsFor;
        $[26] = team.tablePoints;
        $[27] = t14;
      } else {
        t14 = $[27];
      }
      if ($[28] !== t13 || $[29] !== t14) {
        t8 = <span className="mt-2 flex items-center gap-3 text-xs font-black">{t13}{t14}</span>;
        $[28] = t13;
        $[29] = t14;
        $[30] = t8;
      } else {
        t8 = $[30];
      }
      t2 = "mt-3 flex items-center gap-1.5";
      if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <span className="text-[10px] font-black tracking-widest text-[#6f6078] uppercase">L5</span>;
        $[31] = t3;
      } else {
        t3 = $[31];
      }
      t4 = last5.map((r_1, i) => <span key={`${team.team}-${last5.slice(0, i + 1).join("")}`} className={`flex size-5 items-center justify-center text-[10px] font-black ${r_1 === "W" ? "bg-[#22c55e] text-[#0a3d20]" : r_1 === "L" ? "bg-[#ef4444] text-[#3d0a0a]" : "bg-[#a3a3a3] text-[#1a1a1a]"}`}>{r_1}</span>);
    }
    $[2] = name;
    $[3] = team;
    $[4] = teamName;
    $[5] = t10;
    $[6] = t11;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[32] !== t2 || $[33] !== t3 || $[34] !== t4) {
    t12 = <span className={t2}>{t3}{t4}</span>;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
    t13 = <span className={t5}>{t6}{t7}{t8}{t12}</span>;
    $[36] = t12;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t10 || $[43] !== t13 || $[44] !== t9) {
    t14 = <span className={t9}>{t10}{t13}</span>;
    $[42] = t10;
    $[43] = t13;
    $[44] = t9;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
}
function _temp2(r_0) {
  return r_0.result;
}
function _temp(a, b) {
  return a.event - b.event;
}